import React, { useState, useEffect } from 'react';
import ColorPopup from './ColorPopup.js';

const EffectsDialog = ({ isOpen, onClose, onSave, shadowData }) => {

  const [shadowColor, setShadowColor] = useState("#000000");
  const [shadowBlur, setShadowBlur] = useState(0);
  const [regularBlur, setRegularBlur] = useState(0);
  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);

  const [dropShadow, setDropShadow] = useState(true);
  const [blur, setBlur] = useState(false);
  const [glow, setGlow] = useState(false);

  useEffect(() => {
    if (shadowData) {
      setShadowColor(shadowData.shadowColor ?? "#000000");
      setShadowBlur(shadowData.shadowBlur ?? 0);
      setRegularBlur(shadowData.regularBlur ?? 0)
      setOffsetX(shadowData.shadowOffsetX ?? 0);
      setOffsetY(shadowData.shadowOffsetY ?? 0);
      setDropShadow(shadowData.isDropShadow ?? false);
      setBlur(shadowData.isBlur ?? false);
      setGlow(shadowData.isGlow ?? false);
    }
  }, [shadowData]);

  const handleSave = () => {

    if (shadowData) 
    {
        shadowData.shadowColor = shadowColor;
        shadowData.shadowBlur = shadowBlur;
        shadowData.regularBlur = regularBlur;
        shadowData.shadowOffsetX = offsetX;
        shadowData.shadowOffsetY = offsetY;
        shadowData.isDropShadow = dropShadow;
        shadowData.isBlur = blur;
        shadowData.isGlow = glow;
    }

    onSave({
      shadowColor,
      shadowBlur,
      regularBlur,
      offsetX,
      offsetY,
      dropShadow,
      blur,
      glow
    });

    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.dialog}>
        <h2>Shadow & Effects</h2>

        <div>
          <label>Shadow Color:</label>
          <ColorPopup
              color={shadowColor}
              onChange={(shadowColor) => setShadowColor(shadowColor)}                                                      
            />
        </div>

        <div>
          <label>Blur:</label>
          <input
            type="range"
            min="0"
            max="10"
            step="1"
            value={regularBlur}
            onChange={(e) => setRegularBlur(Number(e.target.value))}
            style={styles.slider}
          />
          <span>{regularBlur}</span>
        </div>

        <div>
          <label>Shadow Blur:</label>
          <input
            type="range"
            min="0"
            max="10"
            step="1"
            value={shadowBlur}
            onChange={(e) => setShadowBlur(Number(e.target.value))}
            style={styles.slider}
          />
          <span>{shadowBlur}</span>
        </div>

        <div>
          <label>Offset X:</label>
          <input
            type="range"
            min="-10"
            max="10"
            step="1"
            value={offsetX}
            onChange={(e) => setOffsetX(Number(e.target.value))}
            style={styles.slider}
          />
          <span>{offsetX}</span>
        </div>

        <div>
          <label>Offset Y:</label>
          <input
            type="range"
            min="-10"
            max="10"
            step="1"
            value={offsetY}
            onChange={(e) => setOffsetY(Number(e.target.value))}
            style={styles.slider}
          />
          <span>{offsetY}</span>
        </div>

        <div style={styles.section}>
          <label>
            <input
              type="checkbox"
              checked={dropShadow}
              onChange={() => setDropShadow(prev => !prev)}
            />
            Drop Shadow
          </label>
        </div>

        <div>
          <label>
            <input
              type="checkbox"
              checked={blur}
              onChange={() => setBlur(prev => !prev)}
            />
            Blur
          </label>
        </div>

{/*
        <div>
          <label>
            <input
              type="checkbox"
              checked={glow}
              onChange={() => setGlow(prev => !prev)}
            />
            Glow
          </label>
        </div>
  */}        

        <div style={styles.actions}>
          <button onClick={handleSave}>Save</button>
          <button onClick={onClose}>Cancel</button>
        </div>

      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999999
  },

  dialog: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    width: '300px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  },

  slider: {
    width: '100%'
  },

  section: {
    marginTop: '10px'
  },

  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px'
  }
};

export default EffectsDialog;